import React from 'react'
import { Box } from '@mui/material'
import {
  ALARM_SECTIONS,
  ALARM_SECTION_COLORS,
  ALARM_SECTION_TEXT_COLOR,
  badgeNumber
} from '../../maintenance/alarms&notifications/alarmSections'

// The gap between the two halves, and the ring that separates the pill from the icon under it: the top
// bar's own colour, so it reads as a cut rather than as a line.
const SEPARATOR = '#1e1e1e'

const half = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  px: 0.625,
  color: ALARM_SECTION_TEXT_COLOR,
  fontSize: '0.75rem',
  fontWeight: 700,
  lineHeight: 1,
  fontVariantNumeric: 'tabular-nums'
}

/**
 * Story 162, CA7: the badge of the alarm button, with one half per section.
 *
 * The design is the one the PO chose from the Stitch sheet (concept A, "split pill"): ONE pill on the
 * corner of the triangle, automation in red on the left and general in amber on the right. A section with
 * nothing pending drops its half, so a quiet section stays quiet; with nothing pending in either there is
 * no pill at all. It never wraps: both numbers used to go into a single MUI badge, which wraps its content
 * and broke "199 · 0" onto two lines.
 *
 * @param {{automation: number, general: number}} props What each half counts
 * @returns {JSX.Element|null}
 */
const AlarmCountPill = ({ automation = 0, general = 0 }) => {
  if (automation === 0 && general === 0) return null
  return (
    <Box
      component='span'
      data-testid='alarm-count-pill'
      sx={{ display: 'inline-flex', whiteSpace: 'nowrap', borderRadius: 10, overflow: 'hidden', boxShadow: `0 0 0 1.5px ${SEPARATOR}` }}
    >
      {automation > 0 && (
        <Box component='span' data-testid='alarm-count-AUTOMATION' sx={{ ...half, bgcolor: ALARM_SECTION_COLORS[ALARM_SECTIONS.AUTOMATION] }}>
          {badgeNumber(automation)}
        </Box>
      )}
      {general > 0 && (
        <Box
          component='span'
          data-testid='alarm-count-GENERAL'
          sx={{ ...half, bgcolor: ALARM_SECTION_COLORS[ALARM_SECTIONS.GENERAL], borderLeft: automation > 0 ? `1.5px solid ${SEPARATOR}` : 'none' }}
        >
          {badgeNumber(general)}
        </Box>
      )}
    </Box>
  )
}

export default AlarmCountPill
